import { IOption } from 'src/app/_modules/shared/_interfaces/option';

export const NATIONALITIES: IOption[] = [
  { displayValue: 'Afghanistan', value: 'Afghanistan' },
  { displayValue: 'Albania', value: 'Albania' },
  { displayValue: 'Algeria', value: 'Algeria' },
  { displayValue: 'American Samoa', value: 'American Samoa' },
  { displayValue: 'Andorra', value: 'Andorra' },
  { displayValue: 'Angola', value: 'Angola' },
  { displayValue: 'Anguilla', value: 'Anguilla' },
  { displayValue: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
  { displayValue: 'Argentina', value: 'Argentina' },
  { displayValue: 'Armenia', value: 'Armenia' },
  { displayValue: 'Aruba', value: 'Aruba' },
  { displayValue: 'Australia', value: 'Australia' },
  { displayValue: 'Austria', value: 'Austria' },
  { displayValue: 'Azerbaijan', value: 'Azerbaijan' },
  { displayValue: 'Bahamas', value: 'Bahamas' },
  { displayValue: 'Bahrain', value: 'Bahrain' },
  { displayValue: 'Bangladesh', value: 'Bangladesh' },
  { displayValue: 'Barbados', value: 'Barbados' },
  { displayValue: 'Belarus', value: 'Belarus' },
  { displayValue: 'Belgium', value: 'Belgium' },
  { displayValue: 'Belize', value: 'Belize' },
  { displayValue: 'Benin', value: 'Benin' },
  { displayValue: 'Bhutan', value: 'Bhutan' },
  { displayValue: 'Bolivia', value: 'Bolivia' },
  { displayValue: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
  { displayValue: 'Botswana', value: 'Botswana' },
  { displayValue: 'Brazil', value: 'Brazil' },
  { displayValue: 'Brunei', value: 'Brunei' },
  { displayValue: 'Bulgaria', value: 'Bulgaria' },
  { displayValue: 'Burkina Faso', value: 'Burkina Faso' },
  { displayValue: 'Burundi', value: 'Burundi' },
  { displayValue: 'Cape Verde', value: 'Cape Verde' },
  { displayValue: 'Cambodia', value: 'Cambodia' },
  { displayValue: 'Cameroon', value: 'Cameroon' },
  { displayValue: 'Canada', value: 'Canada' },
  { displayValue: 'Cayman Islands', value: 'Cayman Islands' },
  {
    displayValue: 'Central African Republic',
    value: 'Central African Republic',
  },
  { displayValue: 'Chad', value: 'Chad' },
  { displayValue: 'Chile', value: 'Chile' },
  { displayValue: 'China', value: 'China' },
  { displayValue: 'Colombia', value: 'Colombia' },
  { displayValue: 'Comoros', value: 'Comoros' },
  {
    displayValue: 'Congo (Congo-Brazzaville)',
    value: 'Congo (Congo-Brazzaville)',
  },
  { displayValue: 'Congo (Congo-Kinshasa)', value: 'Congo (Congo-Kinshasa)' },
  { displayValue: 'Cook Islands', value: 'Cook Islands' },
  { displayValue: 'Costa Rica', value: 'Costa Rica' },
  { displayValue: 'Ivory Coast', value: 'Ivory Coast' },
  { displayValue: 'Croatia', value: 'Croatia' },
  { displayValue: 'Cuba', value: 'Cuba' },
  { displayValue: 'Cyprus', value: 'Cyprus' },
  {
    displayValue: 'Czechia (Czech Republic)',
    value: 'Czechia (Czech Republic)',
  },
  { displayValue: 'Denmark', value: 'Denmark' },
  { displayValue: 'Djibouti', value: 'Djibouti' },
  { displayValue: 'Dominica', value: 'Dominica' },
  { displayValue: 'Dominican Republic', value: 'Dominican Republic' },
  { displayValue: 'Ecuador', value: 'Ecuador' },
  { displayValue: 'Egypt', value: 'Egypt' },
  { displayValue: 'El Salvador', value: 'El Salvador' },
  { displayValue: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { displayValue: 'Eritrea', value: 'Eritrea' },
  { displayValue: 'Estonia', value: 'Estonia' },
  {
    displayValue: 'Eswatini (fmr. Swaziland)',
    value: 'Eswatini (fmr. Swaziland)',
  },
  { displayValue: 'Ethiopia', value: 'Ethiopia' },
  { displayValue: 'Finland', value: 'Finland' },
  { displayValue: 'France', value: 'France' },
  { displayValue: 'Gabon', value: 'Gabon' },
  { displayValue: 'Gambia', value: 'Gambia' },
  { displayValue: 'Georgia', value: 'Georgia' },
  { displayValue: 'Germany', value: 'Germany' },
  { displayValue: 'Ghana', value: 'Ghana' },
  { displayValue: 'Greece', value: 'Greece' },
  { displayValue: 'Grenada', value: 'Grenada' },
  { displayValue: 'Guatemala', value: 'Guatemala' },
  { displayValue: 'Guinea', value: 'Guinea' },
  { displayValue: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { displayValue: 'Guyana', value: 'Guyana' },
  { displayValue: 'Haiti', value: 'Haiti' },
  { displayValue: 'Honduras', value: 'Honduras' },
  { displayValue: 'Hong Kong', value: 'Hong Kong' },
  { displayValue: 'Hungary', value: 'Hungary' },
  { displayValue: 'Iceland', value: 'Iceland' },
  { displayValue: 'India', value: 'India' },
  { displayValue: 'Indonesia', value: 'Indonesia' },
  { displayValue: 'Iran', value: 'Iran' },
  { displayValue: 'Iraq', value: 'Iraq' },
  { displayValue: 'Ireland', value: 'Ireland' },
  { displayValue: 'Israel', value: 'Israel' },
  { displayValue: 'Italy', value: 'Italy' },
  { displayValue: 'Jamaica', value: 'Jamaica' },
  { displayValue: 'Japan', value: 'Japan' },
  { displayValue: 'Jordan', value: 'Jordan' },
  { displayValue: 'Kazakhstan', value: 'Kazakhstan' },
  { displayValue: 'Kenya', value: 'Kenya' },
  { displayValue: 'Kiribati', value: 'Kiribati' },
  { displayValue: 'North Korea', value: 'North Korea' },
  { displayValue: 'South Korea', value: 'South Korea' },
  { displayValue: 'Kuwait', value: 'Kuwait' },
  { displayValue: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { displayValue: 'Laos', value: 'Laos' },
  { displayValue: 'Latvia', value: 'Latvia' },
  { displayValue: 'Lebanon', value: 'Lebanon' },
  { displayValue: 'Lesotho', value: 'Lesotho' },
  { displayValue: 'Liberia', value: 'Liberia' },
  { displayValue: 'Libya', value: 'Libya' },
  { displayValue: 'Liechtenstein', value: 'Liechtenstein' },
  { displayValue: 'Lithuania', value: 'Lithuania' },
  { displayValue: 'Luxembourg', value: 'Luxembourg' },
  { displayValue: 'Macau', value: 'Macau' },
  { displayValue: 'North Macedonia', value: 'North Macedonia' },
  { displayValue: 'Madagascar', value: 'Madagascar' },
  { displayValue: 'Malawi', value: 'Malawi' },
  { displayValue: 'Malaysia', value: 'Malaysia' },
  { displayValue: 'Maldives', value: 'Maldives' },
  { displayValue: 'Mali', value: 'Mali' },
  { displayValue: 'Malta', value: 'Malta' },
  { displayValue: 'Marshall Islands', value: 'Marshall Islands' },
  { displayValue: 'Martinique', value: 'Martinique' },
  { displayValue: 'Mauritania', value: 'Mauritania' },
  { displayValue: 'Mauritius', value: 'Mauritius' },
  { displayValue: 'Mayotte', value: 'Mayotte' },
  { displayValue: 'Mexico', value: 'Mexico' },
  { displayValue: 'Micronesia', value: 'Micronesia' },
  { displayValue: 'Moldova', value: 'Moldova' },
  { displayValue: 'Monaco', value: 'Monaco' },
  { displayValue: 'Mongolia', value: 'Mongolia' },
  { displayValue: 'Montenegro', value: 'Montenegro' },
  { displayValue: 'Montserrat', value: 'Montserrat' },
  { displayValue: 'Morocco', value: 'Morocco' },
  { displayValue: 'Mozambique', value: 'Mozambique' },
  { displayValue: 'Myanmar (Burma)', value: 'Myanmar (Burma)' },
  { displayValue: 'Namibia', value: 'Namibia' },
  { displayValue: 'Nauru', value: 'Nauru' },
  { displayValue: 'Nepal', value: 'Nepal' },
  { displayValue: 'Netherlands', value: 'Netherlands' },
  { displayValue: 'New Caledonia', value: 'New Caledonia' },
  { displayValue: 'New Zealand', value: 'New Zealand' },
  { displayValue: 'Nicaragua', value: 'Nicaragua' },
  { displayValue: 'Niger', value: 'Niger' },
  { displayValue: 'Nigeria', value: 'Nigeria' },
  { displayValue: 'Niue', value: 'Niue' },
  { displayValue: 'Norfolk Island', value: 'Norfolk Island' },
  { displayValue: 'Norway', value: 'Norway' },
  { displayValue: 'Oman', value: 'Oman' },
  { displayValue: 'Pakistan', value: 'Pakistan' },
  { displayValue: 'Palau', value: 'Palau' },
  { displayValue: 'Palestine', value: 'Palestine' },
  { displayValue: 'Panama', value: 'Panama' },
  { displayValue: 'Papua New Guinea', value: 'Papua New Guinea' },
  { displayValue: 'Paraguay', value: 'Paraguay' },
  { displayValue: 'Peru', value: 'Peru' },
  { displayValue: 'Philippines', value: 'Philippines' },
  { displayValue: 'Pitcairn Islands', value: 'Pitcairn Islands' },
  { displayValue: 'Poland', value: 'Poland' },
  { displayValue: 'Portugal', value: 'Portugal' },
  { displayValue: 'Puerto Rico', value: 'Puerto Rico' },
  { displayValue: 'Qatar', value: 'Qatar' },
  { displayValue: 'Reunion', value: 'Reunion' },
  { displayValue: 'Romania', value: 'Romania' },
  { displayValue: 'Russia', value: 'Russia' },
  { displayValue: 'Rwanda', value: 'Rwanda' },
  { displayValue: 'Saint Barthelemy', value: 'Saint Barthelemy' },
  { displayValue: 'Saint Helena', value: 'Saint Helena' },
  { displayValue: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
  { displayValue: 'Saint Lucia', value: 'Saint Lucia' },
  { displayValue: 'Saint Martin', value: 'Saint Martin' },
  {
    displayValue: 'Saint Pierre and Miquelon',
    value: 'Saint Pierre and Miquelon',
  },
  {
    displayValue: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
  },
  { displayValue: 'Samoa', value: 'Samoa' },
  { displayValue: 'San Marino', value: 'San Marino' },
  { displayValue: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
  { displayValue: 'Saudi Arabia', value: 'Saudi Arabia' },
  { displayValue: 'Senegal', value: 'Senegal' },
  { displayValue: 'Serbia', value: 'Serbia' },
  { displayValue: 'Seychelles', value: 'Seychelles' },
  { displayValue: 'Sierra Leone', value: 'Sierra Leone' },
  { displayValue: 'Singapore', value: 'Singapore' },
  { displayValue: 'Sint Maarten', value: 'Sint Maarten' },
  { displayValue: 'Slovakia', value: 'Slovakia' },
  { displayValue: 'Slovenia', value: 'Slovenia' },
  { displayValue: 'Solomon Islands', value: 'Solomon Islands' },
  { displayValue: 'Somalia', value: 'Somalia' },
  { displayValue: 'South Africa', value: 'South Africa' },
  {
    displayValue: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands',
  },
  { displayValue: 'Spain', value: 'Spain' },
  { displayValue: 'Sri Lanka', value: 'Sri Lanka' },
  { displayValue: 'Sudan', value: 'Sudan' },
  { displayValue: 'Suriname', value: 'Suriname' },
  { displayValue: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
  { displayValue: 'Sweden', value: 'Sweden' },
  { displayValue: 'Switzerland', value: 'Switzerland' },
  { displayValue: 'Syria', value: 'Syria' },
  { displayValue: 'Taiwan', value: 'Taiwan' },
  { displayValue: 'Tajikistan', value: 'Tajikistan' },
  { displayValue: 'Tanzania', value: 'Tanzania' },
  { displayValue: 'Thailand', value: 'Thailand' },
  { displayValue: 'Timor-Leste', value: 'Timor-Leste' },
  { displayValue: 'Togo', value: 'Togo' },
  { displayValue: 'Tokelau', value: 'Tokelau' },
  { displayValue: 'Tonga', value: 'Tonga' },
  { displayValue: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
  { displayValue: 'Tunisia', value: 'Tunisia' },
  { displayValue: 'Turkey', value: 'Turkey' },
  { displayValue: 'Turkmenistan', value: 'Turkmenistan' },
  {
    displayValue: 'Turks and Caicos Islands',
    value: 'Turks and Caicos Islands',
  },
  { displayValue: 'Tuvalu', value: 'Tuvalu' },
  { displayValue: 'Uganda', value: 'Uganda' },
  { displayValue: 'Ukraine', value: 'Ukraine' },
  { displayValue: 'United Arab Emirates', value: 'United Arab Emirates' },
  { displayValue: 'United Kingdom', value: 'United Kingdom' },
  { displayValue: 'United States', value: 'United States' },
  { displayValue: 'Uruguay', value: 'Uruguay' },
  { displayValue: 'Uzbekistan', value: 'Uzbekistan' },
  { displayValue: 'Vanuatu', value: 'Vanuatu' },
  { displayValue: 'Vatican City', value: 'Vatican City' },
  { displayValue: 'Venezuela', value: 'Venezuela' },
  { displayValue: 'Vietnam', value: 'Vietnam' },
  { displayValue: 'Wallis and Futuna', value: 'Wallis and Futuna' },
  { displayValue: 'Yemen', value: 'Yemen' },
  { displayValue: 'Zambia', value: 'Zambia' },
  { displayValue: 'Zimbabwe', value: 'Zimbabwe' },
];
